import { render } from "./productsSort.vue?vue&type=template&id=436eaa42"
import script from "./productsSort.vue?vue&type=script&lang=js"
export * from "./productsSort.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__